export default __webpack_public_path__ + "static/media/aggregate_sl_active.8aa6d82f.png";